import React from "react";
import PortalModal from "../../../../Components/PortalModal";

export default function PanResultModal({
  show,
  onClose,
  searchResult,
  searchType,
}) {
  if (!show || !searchResult) return null;

  return (
    <PortalModal>
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
        <div className="bg-white rounded-lg shadow-xl w-full max-w-md p-6">
          {/* Success Header */}
          <div className="flex items-center justify-center mb-6">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
              <svg
                className="w-8 h-8 text-green-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
          </div>

          <h3 className="text-xl font-semibold text-center text-gray-800 mb-2">
            PAN Found Successfully!
          </h3>
          <p className="text-sm text-center text-gray-600 mb-6">
            Your search has been completed
          </p>

          {/* PAN Number Display */}
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border-2 border-blue-200 rounded-lg p-6 mb-6">
            <p className="text-xs text-gray-600 text-center mb-2">PAN Number</p>
            <p className="text-3xl font-bold text-blue-900 text-center tracking-wider">
              {searchResult.panNumber || searchResult.pan_number}
            </p>
          </div>

          {/* Search Details */}
          <div className="bg-gray-50 rounded-lg p-4 mb-6 space-y-3">
            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600">Search Method:</span>
              <span className="text-sm font-semibold text-gray-800">
                {searchType === "aadhaar" ? "Aadhaar" : "Phone"}
              </span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600">Search Value:</span>
              <span className="text-sm font-mono font-semibold text-gray-800">
                {searchType === "aadhaar"
                  ? searchResult.aadhaarNumber
                  : searchResult.mobileNumber}
              </span>
            </div>
            {searchResult.requestId && (
              <div className="pt-2 border-t border-gray-200">
                <p className="text-xs text-gray-500 break-all">
                  Request ID: {searchResult.requestId}
                </p>
              </div>
            )}
          </div>

          {/* Close Button */}
          <button
            onClick={onClose}
            className="w-full py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
          >
            Close
          </button>
        </div>
      </div>
    </PortalModal>
  );
}
